// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3Pv58","text":"SelectPayment_text__1ffWb","title":"SelectPayment_title__2b6e4","btn":"SelectPayment_btn__2yfNS"};